import type { ICoreDataWrapper } from '@eureka/services/src/exception';
import type { IProject, IExportParams, ISaveCompanyParams, CatalogItem } from '@/types';
import { container } from '@eureka/services';
import { getLlmModelHeader, LLM_FUNCTION_ID } from '@eureka/utils/llm-model';

// project 函数式请求统一注入所选 LLM 模型 header（functionId 写死）
const llmModelHeader = getLlmModelHeader(LLM_FUNCTION_ID.QUICK_RESEARCH)

export function getProjectInfo(projectId: string) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/${projectId}`
    return container.RnDHttp.get<ICoreDataWrapper<IProject>>({
        url,
        headers: llmModelHeader,
    }).then(res => {
        return res.data
    });
}

export function refreshReportInfo(projectId: string) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/refresh/${projectId}`
    return container.RnDHttp.put<ICoreDataWrapper<IProject>>({
        url,
        headers: llmModelHeader,
    }).then(res => {
        return res.data
    });
}

export function exportReport(params: IExportParams) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/export`
    return container.RnDHttp.post<ICoreDataWrapper<string>>({
        url,
        data: params,
        headers: llmModelHeader,
    }).then(res => {
        return res.data
    });
}

export function saveCompany(data: ISaveCompanyParams) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/add_header_player`
    return container.RnDHttp.post<ICoreDataWrapper<string>>({
        url,
        data,
        headers: llmModelHeader,
    }).then(res => {
        return res.data
    });
}

export function getReportDirectory(projectId: string) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/directory/${projectId}`
    return container.RnDHttp.get<ICoreDataWrapper<CatalogItem[]>>({
        url,
        headers: llmModelHeader,
    }).then(res => {
        return res.data
    });
}
